import { useMemo } from 'react';
import { useHandleAccessCheckPropsForDropdowns } from './useHandleAccessCheckPropsForDropdowns';
export function useHandleOptionsPropForDropdowns(options, checkOptions) {
  const {
    accessPropertiesToCheck,
    elementsWithoutAccessCheckProperties
  } = useMemo(() => checkOptions(options), [options, checkOptions]);
  const {
    accessInfoMap,
    isLoading,
    atLeastOneElementHasAccess
  } = useHandleAccessCheckPropsForDropdowns(accessPropertiesToCheck);
  const toDisplayDropdown = atLeastOneElementHasAccess || elementsWithoutAccessCheckProperties.length > 0;
  return {
    accessInfoMap,
    isLoading,
    toDisplayDropdown
  };
}